import { TFunction } from "i18next";
import { GenericFormFields } from "../../generic-form/GenericFormBody";

export const saveSpecificationsAsTemplateFields = (
  t: TFunction
): GenericFormFields<{ name: string }> => {
  return {
    name: {
      type: "text",
      label: t("specifications.templateName"),
      placeholder: t("specifications.templateName"),
      valueKey: "name",
      showError: true,
      inputProps: {},
    },
  };
};
